import React, { useEffect } from 'react';
import LightbulbFilledIcon from '@atlaskit/icon/glyph/lightbulb-filled';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import CoordinationClient from '@atlassian/jira-engagement';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { AkFlag, useFlagsService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

import type { Props } from './types';

const FLAG_ID = 'tmp_cross_project_parenting_changeboarding' as const;
const EP_MESSAGE_ID = 'JPO-25758-tmp-cross-project-parenting' as const;

export const Flag = ({ hierarchyTitles }: Props) => {
	const { showFlag, dismissFlag } = useFlagsService();
	const { formatMessage } = useIntl();
	useEffect(() => {
		showFlag({
			id: FLAG_ID,
			render: () => (
				<AkFlag
					id={FLAG_ID}
					title={formatMessage(messages.title, {
						epics: hierarchyTitles[1],
						initiatives: hierarchyTitles[2],
					})}
					icon={
						<LightbulbFilledIcon
							label={formatMessage(messages.iconLabel)}
							primaryColor={token('color.icon.subtle', colors.N500)}
						/>
					}
					onDismissed={() => dismissFlag(FLAG_ID)}
				/>
			),
		});
	}, [showFlag, dismissFlag, formatMessage, hierarchyTitles]);

	return null;
};

const TmpCrossProjectChangeBoarding = (props: Props) => (
	<JSErrorBoundary
		id="tmpCrossProjectChangeBoarding"
		packageName="jiraPortfolio3Onboarding"
		teamName="chronos"
		fallback="flag"
	>
		<CoordinationClient messageId={EP_MESSAGE_ID}>
			<Flag {...props} />
		</CoordinationClient>
	</JSErrorBoundary>
);

export default TmpCrossProjectChangeBoarding;
